/**
 * Blogs hub feed: category filter and "Load more".
 * Works on cards already in the HTML. Does not change the URL and makes no requests.
 */
class BlogsFeed extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.batch = Number(this.dataset.batch) || 12;
    this.items = Array.from(this.querySelectorAll('.blogs-feed__item'));
    this.pills = Array.from(this.querySelectorAll('.blogs-feed__pill'));
    this.moreWrapper = this.querySelector('.blogs-feed__more');
    this.moreButton = this.querySelector('.blogs-feed__more-button');
    this.category = 'all';
    this.visibleCount = this.batch;

    this.pills.forEach((pill) => {
      pill.addEventListener('click', () => this.setCategory(pill.dataset.filter || 'all'));
    });

    if (this.moreButton) {
      this.moreButton.addEventListener('click', () => this.showMore());
    }

    this.render();
  }

  get matchingItems() {
    if (this.category === 'all') return this.items;
    return this.items.filter((item) => item.dataset.category === this.category);
  }

  setCategory(category) {
    if (category === this.category) return;

    this.category = category;
    this.visibleCount = this.batch;
    this.pills.forEach((pill) => {
      pill.setAttribute('aria-pressed', String(pill.dataset.filter === category));
    });
    this.render();
  }

  showMore() {
    const firstNewIndex = this.visibleCount;
    this.visibleCount += this.batch;
    this.render();

    const firstNew = this.matchingItems[firstNewIndex];
    const link = firstNew && firstNew.querySelector('a');
    if (link) link.focus({ preventScroll: true });
  }

  render() {
    const matching = new Set(this.matchingItems.slice(0, this.visibleCount));
    this.items.forEach((item) => {
      item.hidden = !matching.has(item);
    });

    if (this.moreWrapper) {
      this.moreWrapper.hidden = this.matchingItems.length <= this.visibleCount;
    }
  }
}

if (!customElements.get('blogs-feed')) {
  customElements.define('blogs-feed', BlogsFeed);
}
